import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Battle, BattleResultChange, BattleResultChangeRequest } from '../models/battle';

@Injectable({
  providedIn: 'root',
})
export class BattleService {
  constructor(private http: HttpClient) { }

  getResultChange(publicId: string): Observable<BattleResultChange> {
    return this.http.get<BattleResultChange>(`${environment.apiUrl}/battles/${publicId}/change_result/`);
  }

  changeResult(publicId: string, data: BattleResultChangeRequest): Observable<BattleResultChange> {
    return this.http.post<BattleResultChange>(`${environment.apiUrl}/battles/${publicId}/change_result/`, data);
  }

  getBattles(params?: {
    is_finished?: boolean;
    search?: string;
    since?: string;
    until?: string;
    page?: number;
    page_size?: number;
    exact_match?: boolean;
  }): Observable<{ count: number; results: Battle[] }> {
    let httpParams = new HttpParams();
    
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }

    return this.http.get<{ count: number; results: Battle[] }>(`${environment.apiUrl}/battles/admin_list/`, { params: httpParams });
  }

  resolveBattle(battlePublicId: string): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/battles/${battlePublicId}/resolve/`,
      {}
    );
  }

  refundBattle(publicId: string): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/battles/${publicId}/refund/`,
      null
    );
  }
}

